import { render, staticRenderFns } from "./NavBarComponent.vue?vue&type=template&id=08ab12c2&scoped=true&"
import script from "./NavBarComponent.vue?vue&type=script&lang=js&"
export * from "./NavBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavBarComponent.vue?vue&type=style&index=0&id=08ab12c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab12c2",
  null
  
)

export default component.exports